import {
	type AstNode,
	DefaultWorkspaceManager,
	type LangiumDocument,
	type LangiumDocumentFactory,
	URI,
	type WorkspaceFolder,
} from "langium";
import type { LangiumSharedServices } from "langium/lsp";

import { BUILTIN_LIBRARY, BUILTIN_LIBRARY_URI } from "../builtin/index.js";

export class IprotoWorkspaceManager extends DefaultWorkspaceManager {
	private documentFactory: LangiumDocumentFactory;

	constructor(services: LangiumSharedServices) {
		super(services);
		this.documentFactory = services.workspace.LangiumDocumentFactory;
	}

	protected override async loadAdditionalDocuments(
		folders: WorkspaceFolder[],
		collector: (document: LangiumDocument<AstNode>) => void,
	): Promise<void> {
		await super.loadAdditionalDocuments(folders, collector);
		collector(this.documentFactory.fromString(BUILTIN_LIBRARY.trim(), URI.parse(BUILTIN_LIBRARY_URI)));
	}
}
